module.exports = __webpack_public_path__ + "assets/img/title_2.b8e2c2ed.png";